import React from "react";

const Preloader = () => {
  return (
    <div className="preloader">
      <div className="loading-container">
        <div className="loading"></div>
        <div id="loading-icon">
          <img src="/assets/images/fav-ic.png" alt="Loading Icon" loading="lazy" />
        </div>
      </div>
    </div>
  );
};

export default Preloader;
